@if (showAccountServiceRequests) {
  <div class="field-control">
    <div class="border border-dc-navy text-dc-navy">
      <!-- HEADER BAR -->
      <div
        class="flex items-center px-2 py-4 bg-[#F6F9FA] border-b border-dc-navy"
      >
        <h1 class="font-semibold text-xl">
          {{ "INFO_SERVICE.SELECT_AMENDMENT_SR" | translate }}
        </h1>

        <!-- Search -->
        <div class="ltr:ml-auto rtl:mr-auto">
          <div class="flex items-center border border-dc-navy px-3 py-2">
            <input
              type="text"
              [placeholder]="'INFO_SERVICE.SEARCH_IN_LIST' | translate"
              class="text-sm outline-none w-44"
              [formControl]="searchCooNumber"
              (keyup)="(false)"
            />
            <i class="fas fa-search text-dc-navy ms-2"></i>
          </div>
        </div>
      </div>
      <app-table
        [tableHeadings]="[
          'INFO_SERVICE.SR_NUMBER' | translate,
          'INFO_SERVICE.CREATED_DATE' | translate,
          'INFO_SERVICE.BUYER' | translate,
          'INFO_SERVICE.INVOICE_NUMBER' | translate,
        ]"
        [dataKeys]="[
          'SR Number',
          'Created',
          'DC Buyer',
          'DC Invoice Number',
        ]"
        [listData]="paginatedRequests"
        [loader]="accountServiceRequestsLoading"
        [showActions]="true"
        [showPagination]="true"
        [pageSize]="pageSize"
        [totalRecords]="filteredRequests.length"
        [otherAction]="true"
        [otherActionText]="'BUTTONS.APPY_AMENDMENT' | translate"
        [showActionHeading]="true"
        (otherActionClick)="applyAccountServiceRequest($event)"
        (onPageChange)="onPageChange($event)"
      ></app-table>
    </div>
  </div>
}
